import { useState, useCallback, useEffect, useRef } from 'react';
import { getFileUrl } from '../lib/api';

export function usePhotoBlobs(photos) {
  const [photoBlobs, setPhotoBlobs] = useState({});
  const blobsRef = useRef({});

  useEffect(() => {
    blobsRef.current = photoBlobs;
  }, [photoBlobs]);

  const loadBlob = useCallback(async (photo) => {
    if (blobsRef.current[photo.id]) return;
    try {
      const url = getFileUrl(photo.storage_path);
      const response = await fetch(url, { credentials: 'include' });
      if (!response.ok) return;
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      setPhotoBlobs(prev => ({ ...prev, [photo.id]: blobUrl }));
    } catch (err) {
      // Photo load failed — UI continues showing loader placeholder
      void err;
    }
  }, []);

  useEffect(() => {
    photos.forEach(photo => loadBlob(photo));
  }, [photos, loadBlob]);

  useEffect(() => {
    const ref = blobsRef;
    return () => {
      Object.values(ref.current).forEach(url => URL.revokeObjectURL(url));
    };
  }, []);

  const removeBlob = useCallback((photoId) => {
    if (blobsRef.current[photoId]) {
      URL.revokeObjectURL(blobsRef.current[photoId]);
      setPhotoBlobs(prev => {
        const next = { ...prev };
        delete next[photoId];
        return next;
      });
    }
  }, []);

  return { photoBlobs, removeBlob };
}
